import usersActions from './users';
import seasonsActions from './seasons';

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const SWITCH_LOCALE = "SWITCH_LOCALE";
export const SWITCH_TIMEZONE = "SWITCH_TIMEZONE";
export const CREATE_PROPERTY = "CREATE_PROPERTY";
export const ACTIVE_PROPERTY = "ACTIVE_PROPERTY";

export function loginAction(credentials) {
	
	return {
		types: ['LOGIN_REQUEST', 'LOGIN_SUCCESS', 'LOGIN_FAILURE'],
		payload: {
			request:{
				method: 'POST',
				url:'/users/login',
				data: credentials
			}
		}
	}
}

export function resetPasswordAction(credentials) {
	return {
		types: ['RESET_REQUEST', 'RESET_SUCCESS', 'RESET_FAILURE'],
		payload: {
			request: {
				method: 'POST',
				url: '/users/passwordReset',
				data: credentials
			}
		}
	}
}

export function login(credentials) {
	return function (dispatch) {
		return dispatch(loginAction(credentials)).then((response) => {
			//console.log(`response:`, response);
			if(response.type === 'LOGIN_SUCCESS'){
				// dispatch(contactLevelsActions.fetch('contact_levels', { limit: 50 }))
                dispatch(seasonsActions.fetch('init_property', {}));
			}
		});
	}
}

export function reset_password(credentials) {
	return function (dispatch) {
		return dispatch(resetPasswordAction(credentials))
	}
}


export function logout() {
	delete localStorage.authToken;
	delete localStorage.rulesToken;
	return { type: LOGOUT }
}
export function switchLocale(payload) {
    return function (dispatch) {
		return dispatch(usersActions.update('users', { id:payload.user.id, language: payload.locale.language, locale_id: payload.locale.locale })).then((response) => {
			//console.log(`response:`, response);
			dispatch({ type: SWITCH_LOCALE, payload });
		});
    }
	//return { type: SWITCH_LOCALE, payload }
}
export function switchTimezone(payload) {
	return { type: SWITCH_TIMEZONE, payload }
}
export function activeProperty(payload) {
	return function (dispatch) {
        localStorage.activeProperty = JSON.stringify(payload);
        dispatch(seasonsActions.fetch('init_property', {}));
		dispatch({ type: ACTIVE_PROPERTY, payload });
	}
}
export function createProperty() {
	return { type: CREATE_PROPERTY }
}